// initial state
const state = () => ({
    authenticated: false,
    user: null,
    staySamePage: false,
});

// getters
const getters = {
    getAuthUserInfo: (state) => {
        return state.user;
    },
    isAuthenticated: (state) => {
        return state.authenticated;
    },
    getStaySamePage: (state) => {
        return state.staySamePage;
    },
};

// actions
const actions = {};

// mutations
const mutations = {
    setAuthUserInfo(state, user) {
        state.user = user;
    },
    setAuthenticated(state, status) {
        state.authenticated = status;
    },
    setStaySamePage(state, status) {
        state.staySamePage = status;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
